import { AddOutlined, DeleteOutline, EditOutlined, List } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CustomButton, FilterBar, TableData } from "../../../../components";
import { confirmAlert, errorAlert } from "../../../../helpers/alerts";
import { removePINProduct, setCurrentPINProduct, setPINProducts, setPINSegments, updatePINProduct } from "redux/slices/admin/productSlice";
import { getAllPINProductsService, getPINSegmentsService, removePINProductService, updatePINProductService } from "services/admin/productService";
import { validatePermission } from "helpers/authentication";
import { Box } from "@mui/system";
import { sortArrayBy } from "helpers/util";

const ProductsPINScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pinSegments, pinProducts, currentPINSegment, justPINProducts } = useSelector((state) => state.products);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getPINSegmentsService().then(list => {
      dispatch(setPINSegments(list));
    }).catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  const handlerSegments = () => navigate("segmentos");
  const handlerAdd = () => navigate("productos/crear");

  const handlerEdit = (row) => {
    dispatch(setCurrentPINProduct(row));
    navigate("productos/editar");
  };

  const handlerCheck = async ({ id, idSegment }, currentValue, col) => {
    const value = !currentValue;
    updatePINProductService(idSegment?.id, id, { [col]: value })
      .then(() => dispatch(updatePINProduct({ id, data: { [col]: value } })))
      .catch(error => errorAlert(error))

  };

  const handlerDelete = ({ id, name, idSegment }) => {
    confirmAlert({
      title: "Estas seguro que deseas eliminar este segmento?",
      text: `El segmento ${name} será eliminado.`,
      onConfirm: async () => {
        try {
          await removePINProductService(idSegment?.id, id,);
          dispatch(removePINProduct(id));
        }
        catch (error) {
          errorAlert(error)
        }
      }
    })
  };

  const handlerChangeSegment = async (idSegment, product) => {
    updatePINProductService(idSegment, product.id)
      .then(() => dispatch(updatePINProduct({ id: product.id, data: { idSegment: { id: idSegment } } })))
      .catch(error => errorAlert(error))
  }

  const handlerSubmit = (data) => {
    setLoading(true);
    getAllPINProductsService(data)
      .then((data) => dispatch(setPINProducts(data)))
      .catch(error => errorAlert(error))
      .finally(() => setLoading(false))
  }

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        showTitle={false}
        filters={[
          {
            name: "segments",
            label: "Segmento",
            type: "select",
            multiple: true,
            data: pinSegments.map(({ id, name }) => ({ id, name })),
            render: (value) => value.map((id) => {
              const segment = pinSegments.find(o => o.id === id);
              return segment.name;
            }).join(', '),
          },
        ]}
      />
      <Box mt={-5}>
        <TableData
          dataRows={sortArrayBy(pinProducts, a => a.name)}
          loading={loading}
          headerButtons={[
            <CustomButton
              icon={<List />}
              key="segments"
              name={"Segmentos"}
              click={handlerSegments}
            />,
            validatePermission('productos', 'productos', ['agregar']) && !justPINProducts &&
            <CustomButton
              dark={true}
              icon={<AddOutlined />}
              key="addProduct"
              name={"Producto"}
              click={handlerAdd}
            />,
          ]}
          dataTitle={["Logo", "Nombre", "SKU(s)", "Segmento", "Estado"]}
          formatter={({ name, code, state, idSegment, fd, fixedAmount, amounts }) => [
            { type: "img", value: `/v3/file/${fd}/` },
            name,
            fixedAmount ? amounts.map(({ sku }) => sku).join(', ') : code,
            {
              name: "segment",
              type: "select_button",
              label: 'Segmento',
              list: pinSegments.map(({ id, name }) => ({ id, name })),
              value: idSegment?.id,
              onChange: handlerChangeSegment
            },
            { name: "state", type: "boolean", value: state },
          ]}
          onChecked={handlerCheck}
          actions={[
            {
              label: "Editar",
              icon: <EditOutlined />,
              onClick: (data) => {
                handlerEdit(data);
              },
            },
            {
              label: "Eliminar",
              icon: <DeleteOutline />,
              onClick: (data) => {
                handlerDelete(data);
              },
            },
          ]}
        />
      </Box>
    </>
  );
};

export default ProductsPINScreen;
